export default "__VITE_ASSET__f71b08c7__$_?url=__"